import React,{useContext} from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import {SoundContext} from "./SoundContext";
import Settings from './Settings';
// import usePlaySound from '../hooks/usePlaySound';
import SoundButtonPlayer from './SoundButtonPlayer';

const SOUND_ON = "/assets/icons/soundon-mode.png";
const SOUND_OFF = "/assets/icons/soundoff-mode.png";

const SON_NAME = "Record On"
const SOFF_NAME = "Record Off"

function SoundToggle(){
    const {isSoundOn,toggleSound} = useContext(SoundContext);

    const imgToUse = isSoundOn ? SOUND_ON : SOUND_OFF
    const btnName = isSoundOn ? SON_NAME : SOFF_NAME

    // const playTypeSound = usePlaySound('/assets/audio/typing.mp3');

    const handleToggleClick =()=>{
        toggleSound();//togglesound passed in
    }

    return(
        <div  className = "App">
            <SoundButtonPlayer onClick={handleToggleClick}>
                {/* <img src={imgToUse} alt={btnName} className="settingIcon"/> */}
                <Settings
                    settingImg={imgToUse}
                    settingName={btnName}
                />
            </SoundButtonPlayer>
             
        </div>
    );
}
export default SoundToggle;